import React, {useState, useEffect, useRef} from "react";
import Skeleton from "react-loading-skeleton";
import {Table} from "antd";
import ApiService from "../util/ApiService";
import CustomPagination from "../util/CustomPagination";
import {DollarCircleOutlined} from "@ant-design/icons";

const HistoryTransaction = () => {


    // Estados para histórico de transações
    const [paymentHistoryTransaction, setPaymentHistoryTransaction] = useState([]);
    const [loadingPaymentTransaction, setLoadingPaymentTransaction] = useState(true);

    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});



    // Colunas para a tabela de transações
    const transactionColumns = [
        {
            title: "Plataforma",
            dataIndex: "platforms",
            key: "platforms",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
        },
        {
            title: "Data de Criação",
            dataIndex: "creationDate",
            key: "creationDate",
            render: (date) => new Date(date).toLocaleString(),
        },
    ];


    // Função para buscar o histórico de transações
    const fetchHistoryTransaction = async (page = 1, limit = 10) => {
        try {
            setLoadingPaymentTransaction(true);
            const response = await ApiService.send("get", `${process.env.REACT_APP_URL_API}payment/history-transaction`, {
                page,
                per_page: limit
            }, true);

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);

            setPaymentHistoryTransaction(data || []);

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPaymentTransaction(false);
        }
    };


    // Controle para evitar chamada dupla na montagem para histórico de transações
    useEffect(() => {
           fetchHistoryTransaction(pagination.current, pagination.limit);
    }, []);

    return (
        <div className="row" style={{marginTop: "20px"}}>
            <div className="col-12">
                <div className="card">
                    <div className="header-section">
                        <h6 className="card-title" style={{marginTop: '10px', marginLeft: '10px'}}>
                            <DollarCircleOutlined/> Histórico de Pagamentos</h6>
                    </div>
                    <div className="card-body">


                        {loadingPaymentTransaction ? (
                            <Skeleton width="100%" height={150}/>
                        ) : paymentHistoryTransaction.length > 0 ? (
                            <>
                                <Table
                                    dataSource={paymentHistoryTransaction}
                                    columns={transactionColumns}
                                    pagination={false}
                                    rowKey="creationDate"
                                    style={{
                                        backgroundColor: "#f0f5ff",
                                        borderRadius: "5px",
                                    }}
                                />
                                <CustomPagination
                                    pagination={pagination}
                                    onChange={(page) => setTransactionPage(page)}
                                />
                            </>
                        ) : (
                            <p>Sem dados disponíveis.</p>
                        )}

                    </div>


                </div>
            </div>
        </div>
    );
};

export default HistoryTransaction;
